import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import { getStockColor, StockDetail } from '.';
import { optionsTable } from './config';

interface TableChart {
  stockData: Array<StockDetail>;
  height?: number;
  width?: number;
  className?: string;
}
const StockChartTable: React.FC<TableChart> = ({
  stockData,
  height = 70,
  width = 300,
  className = '',
}) => {
  const stockColor = getStockColor(stockData);
  const stockOptions = optionsTable([...stockData], stockColor, height, width);
  return (
    <div className={className}>
      <HighchartsReact highcharts={Highcharts} options={{ ...stockOptions }} />
    </div>
  );
};

export { StockChartTable };
